import React, { ReactNode } from 'react';
import Wrapper from '../Wrapper';
import Avatar from '../Avatar/Avatar';
import './PreviewListItem.less';

export type PreviewListItemProps = {
  name?: string;
  avatar?: string;
  date?: any;
  hover?: boolean;
  withBg?: boolean;
  actions: ReactNode;
  onItemClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
};

const TPreviewListItem: React.FC<PreviewListItemProps> = ({
  onItemClick,
  name,
  actions,
  avatar,
  date = '',
  hover = false,
  withBg = false,
}) => {
  const classNames = [];
  if (!!hover) {
    classNames.push('t-preview-list-item-hover');
  }
  if (!!withBg) {
    classNames.push('t-preview-list-item-withBg');
  }
  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      <Wrapper
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        divider
        py={1}
        pl={2}
        pr={2}
      >
        <div className="t-preview-list-avatar-section">
          <Avatar src={avatar} name={name} text={name} description={date} />
        </div>
        <div>{actions}</div>
      </Wrapper>
    </div>
  );
};

export default TPreviewListItem;
